"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateRules = validateRules;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _utils = require("../../utils");

var _locale = require("../../locale");

function validatorMaxOrMin(type) {
  return function (data, value) {
    value = Number(value);

    if (isNaN(value)) {
      // message.error('validatorRules: can not set value not number!');
      return true;
    }

    if (type === 'maxLength' || type === 'minLength') {
      if (data && data.length !== undefined) {
        return type === 'maxLength' ? data.length <= value : data.length >= value;
      } else {
        return true;
      }
    } else {
      // 是数字
      return type === 'max' ? data <= value : data >= value;
    }
  };
}

var validatorRules = {
  required: {
    validator: function validator(data) {
      return (0, _utils.notNull)(data) && data !== '' && (!Array.isArray(data) || !!data.length);
    }
  },
  min: {
    validator: validatorMaxOrMin('min')
  },
  max: {
    validator: validatorMaxOrMin('max')
  },
  minLen: {
    validator: validatorMaxOrMin('minLength')
  },
  maxLen: {
    validator: validatorMaxOrMin('maxLength')
  },
  isPhone: {
    validator: function validator(data) {
      return !data || /^1[3456789]\d{9}$/.test(data);
    }
  },
  pattern: {
    validator: function validator(data, value) {
      return new RegExp(value).test(data);
    }
  },
  isEmail: {
    validator: function validator(data) {
      return !data || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(data);
    }
  }
};

function validateRules(_x, _x2, _x3) {
  return _validateRules.apply(this, arguments);
}

function _validateRules() {
  _validateRules = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data, rules, trigger) {
    var errors, i, rule, result, message, validatorObj;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errors = [];
            i = 0;

          case 2:
            if (!(i < rules.length)) {
              _context.next = 28;
              break;
            }

            rule = rules[i];

            if (!(rule.trigger && !rule.trigger.includes(trigger))) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("continue", 25);

          case 6:
            // 当前效验规则
            result = void 0;
            message = void 0;
            validatorObj = validatorRules[rule.type];

            if (!rule.validator) {
              _context.next = 16;
              break;
            }

            _context.next = 12;
            return rule.validator(data, rule.value);

          case 12:
            result = _context.sent;
            message = rule.message;
            _context.next = 23;
            break;

          case 16:
            if (!validatorObj) {
              _context.next = 22;
              break;
            }

            result = validatorObj.validator(data, rule.value || validatorObj.defaultValue);
            message = rule.message;

            if (!(0, _utils.notNull)(message)) {
              message = (0, _locale.tl)('mhForm.' + rule.type);
            }

            _context.next = 23;
            break;

          case 22:
            return _context.abrupt("continue", 25);

          case 23:
            message = message && message.replace(/%v/g, rule.value || '');

            if (!result) {
              errors.push(message || 'error');
            }

          case 25:
            ++i;
            _context.next = 2;
            break;

          case 28:
            return _context.abrupt("return", errors);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _validateRules.apply(this, arguments);
}